import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles } from "../../../theme/mixins";

interface IWrapperProps {
  isIE?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.colors.white};
  position: fixed;
  right: 15px;
  top: 136px;
  width: ${(props: IWrapperProps) => (props.isIE ? "325px" : "345px")};
  height: calc(100vh - 150px);
  overflow: hidden;

  ${mediaMinWidth.mediumScreen} {
    width: 390px;
  }

  ${mediaMinWidth.largeScreen} {
    width: 490px;
  }

  ${mediaMaxWidth.tablet} {
    position: fixed;
    top: 0;
    right: -100vw;
    z-index: 6;
    border-radius: 0;
    box-shadow: none;
    width: 100vw;
    height: 100vh;
    transition: 0.1s ease-in-out;

    &.active {
      right: 0;
    }
  }
`;

export const Header = styled.header`
  ${cardHeaderStyles};
  padding: 15px 10px 5px 10px;
  margin: 0 20px;

  ${mediaMaxWidth.tablet} {
    margin: 0 10px;
  }
`;

export const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  display: flex;
  justify-content: space-between;
  text-transform: capitalize;
  position: relative;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

export const BetaBadge = styled.span`
  background-color: ${({ theme }) => theme.colors.primary};
  font-size: 0.55em;
  color: ${({ theme }) => theme.colors.white};
  padding: 1px 5px;
  border-radius: 8px;
  position: absolute;
  top: -10px;
  right: -30px;
  text-transform: uppercase;

  ${mediaMaxWidth.tablet} {
    top: -5px;
    right: -35px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 12px;
  top: 5px;
  font-size: 1.4em;
  background-color: ${({ theme }) => theme.colors.white};
  border: none;

  &:focus {
    outline: none;
  }

  ${mediaMinWidth.tablet} {
    display: none;
  }
`;

interface IFeedWrapperProps {
  isIE?: boolean;
}

export const FeedWrapper = styled.div`
  padding: ${(props: IFeedWrapperProps) =>
    props.isIE ? "0 0 0 20px" : "0 20px"};
  overflow: scroll;
`;

export const PostWrapper = styled.div`
  border: ${({ theme }) => `2px solid ${theme.colors.primary}`};
  border-radius: ${({ theme }) => theme.borderRadiusSmall};
  display: flex;
  margin: 10px 0;
  padding: 15px 10px 30px 10px;
  position: relative;
`;

export const EmojiWrapper = styled.div`
  width: 30px;
  height: 50px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 1.5em;

  ${mediaMinWidth.largeScreen} {
    width: 50px;
    font-size: 2em;
  }
`;

export const TextWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  width: calc(100% - 48px);

  a {
    color: ${({ theme }) => `${theme.colors.primaryTextColor} !important`};
    text-decoration: underline !important;

    &:hover {
      color: ${({ theme }) => `${theme.colors.primary} !important`};
    }
  }

  ${mediaMinWidth.largeScreen} {
    width: calc(100% - 68px);
  }

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

export const Date = styled.div`
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: ${({ theme }) => theme.fontSize.small.desktop};
  font-style: italic;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.small.mobile};
  }
`;

export const NoPosts = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Error = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Loaded = styled.div`
  text-align: center;
  margin: 60px 0 20px 0;

  ${mediaMaxWidth.tablet} {
    margin: 60px 0 80px 0;
  }
`;
